<template>
  <div v-show="showTable">
    <!-- 1. 使用 flex 布局包裹标题和自定义的复制按钮 -->
    <div style="display: flex; align-items: center; justify-content: space-between;">
      <div style="font-size: 0.8em; font-weight: bold;">参数提取</div>
      <!-- 2. 使用标准 el-button，并绑定自定义的复制方法 -->
      <el-button @click="handleCopyTable" size="small" style="border-radius: 15px;right: 0px"
                 :disabled="!transformedParameters.length">
        复制表格
      </el-button>
    </div>

    <el-table
        :key="tableKey"
        :data="transformedParameters"
        :header-cell-style="{ color: 'black' }"
        style="width: 100%; margin-top: 10px"
    >
      <!-- 固定列：参数项目 -->
      <el-table-column prop="keyword" label="参数项目" min-width="120"/>

      <!-- 固定列：值1 -->
      <el-table-column label="值1" min-width="80">
        <template #default="{ row }">
          <div v-if="row.type === 'int' || row.type === 'str'">
            <span v-if="!row.isEditing">{{ row.value }}</span>
            <el-input v-else v-model="row.editValue.minValue" size="small" placeholder="值"/>
          </div>
          <div v-else-if="row.type === 'range'">
            <span v-if="!row.isEditing">{{ row.min }}</span>
            <el-input v-else v-model="row.editValue.minValue" size="small" placeholder="下限值"/>
          </div>
          <div v-else-if="row.type === 'enumeration'">
            <span v-if="!row.isEditing">{{ row.value }}</span>
            <el-select
                v-else
                v-model="row.editValue.minValue"
                size="small"
                placeholder="请选择"
                style="width: 100%;"
            >
              <el-option
                  v-for="item in (row.enumeration)"
                  :key="item"
                  :label="item"
                  :value="item"
              />
            </el-select>
          </div>

          <span v-else>—</span>
        </template>
      </el-table-column>

      <!-- 固定列：值2 -->
      <el-table-column label="值2" min-width="80">
        <template #default="{ row }">
          <div v-if="row.type === 'range'">
            <span v-if="!row.isEditing">{{ row.max }}</span>
            <el-input v-else v-model="row.editValue.maxValue" size="small" placeholder="上限值"/>
          </div>
          <span v-else>—</span>
        </template>
      </el-table-column>

      <!-- 固定列：单位/枚举值 -->
      <el-table-column label="单位" min-width="80">
        <template #default="{ row }">
          <!-- int 和 range 有单位， 其他无-->
          <div v-if="row.type === 'int' || row.type === 'range'">
            <span v-if="!row.isEditing">
               {{ row.unit }}
            </span>
            <el-select
                v-else
                v-model="row.editValue.unit"
                size="small"
                placeholder="请选择"
                style="width: 100%;"
            >
              <el-option
                  v-for="item in (row.unit_options)"
                  :key="item"
                  :label="item"
                  :value="item"
              />
            </el-select>
          </div>
          <span v-else>—</span>

        </template>
      </el-table-column>

      <!-- 固定列：操作 -->
      <el-table-column label="操作" width="140" align="center">
        <template #default="{ row }">
          <div v-if="!row.isEditing">
            <el-button size="small" type="primary" link @click="handleEdit(row)">修改</el-button>
            <el-button size="small"
                       type="primary"
                       link @click="handleLocate(row)"
                       :disabled="!(row.boxes && row.boxes.length > 0)">
              定位
            </el-button>
          </div>
          <div v-else>
            <el-button size="small" type="success" @click="handleConfirm(row)">确认</el-button>
            <el-button size="small" @click="handleCancel(row)">取消</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {ElMessage} from 'element-plus';
import {showRowBoxImg} from "@/components/file_process_js/ function_process/vision_box_process";
import {mapState} from "vuex";
import store from "@/store";
import {locationByPathKeyword} from "@/components/file_process_js/utils";

export default {
  name: 'KVParameterTable',
  props: {
    fileInfo: {type: Object, required: true},
    positionKey: {type: String, required: true}
  },
  data() {
    return {
      transformedParameters: [],
      showTable: false,
      lastFileInfoStatusCode: 0,
      tableKey: 0,
    };
  },
  computed: {
    ...mapState(['checkListChangeSign']),
  },
  watch: {
    'fileInfo.position_params': {
      immediate: true,
      deep: false,
      handler(newVal) {
        this.refreshTable()
      }
    },
    checkListChangeSign(currentSign) {
      if (currentSign && this.lastFileInfoStatusCode !== this.fileInfo.status_code) {
        console.log("table start refresh");
        this.refreshTable()
      }
    }
  },
  methods: {
    // 3. 新增的自定义复制方法
    handleCopyTable() {
      if (!this.transformedParameters || this.transformedParameters.length === 0) {
        ElMessage.warning('表格数据为空');
        return;
      }
      // 手动定义表头，确保与界面一致
      const headers = ['参数项目', '值1', '值2', '单位'].join('\t');

      const dataRows = this.transformedParameters.map(row => {
        let value1 = '—';
        let value2 = '—';
        let unitOrEnum = '—';

        // 根据类型，精确提取每列的数据，逻辑与 template 中完全一致
        switch (row.type) {
          case 'int':
          case 'str':
          case 'enumeration':
            value1 = row.value ?? '';
            unitOrEnum = row.unit ?? '—';
            break;
          case 'range':
            value1 = row.min ?? '';
            value2 = row.max ?? '';
            unitOrEnum = row.unit ?? '—';
            break;
        }

        // 清理数据，防止制表符或换行符破坏格式
        const sanitize = (str) => String(str).replace(/\t/g, ' ').replace(/\n/g, ' ');

        return [
          sanitize(row.keyword),
          sanitize(value1),
          sanitize(value2),
          sanitize(unitOrEnum)
        ].join('\t');
      }).join('\n');

      const tableText = `${headers}\n${dataRows}`;

      navigator.clipboard.writeText(tableText)
          .then(() => {
            ElMessage.success('表格数据已复制，可进入WPS进行粘贴');
          })
          .catch(err => {
            ElMessage.error('复制失败');
            console.error('复制失败:', err);
          });
    },

    refreshTable() {
      this.transformedParameters = [];
      const position_params = this.fileInfo.position_params;
      this.lastFileInfoStatusCode = this.fileInfo.status_code;
      if (!position_params || !position_params[this.positionKey] || !position_params[this.positionKey].kvParams) {
        this.showTable = false;
        return;
      }
      const sourceParams = position_params[this.positionKey].kvParams;
      let hasData = false;
      for (let i = 0; i < sourceParams.length; i++) {
        if (sourceParams[i].res && sourceParams[i].res.length > 0) {
          hasData = true;
          sourceParams[i].res.forEach((resItem) => {
            this.transformData(sourceParams[i], resItem)
            this.transformedParameters.push(resItem);
          });
        }
      }
      this.showTable = hasData;
      this.tableKey += 1;
    },

    transformData(param, row) {
      row.enumeration = param.enumeration
      row.unit_options = param.unit_options

      row.isEditing = row.isEditing || false
      row.editValue = {
        minValue: null,
        maxValue: null,
        unit: null,
      }
    },

    transformDataForSaving(row) {
      switch (row.type) {
        case 'int':
        case 'str':
        case 'enumeration':
          row.value = row.editValue.minValue;
          row.unit = row.editValue.unit;
          break;
        case 'range':
          row.min = row.editValue.minValue;
          row.max = row.editValue.maxValue;
          row.unit = row.editValue.unit;
          break;
      }
    },

    handleEdit(row) {
      console.log("handleEdit", row);
      row.isEditing = true;
      switch (row.type) {
        case 'int':
        case "str":
        case 'enumeration':
          row.editValue.minValue = row.value;
          row.editValue.unit = row.unit;
          break;
        case 'range':
          row.editValue.minValue = row.min;
          row.editValue.maxValue = row.max;
          row.editValue.unit = row.unit;
          break;
      }
    },

    async handleConfirm(row) {
      this.transformDataForSaving(row);
      row.isEditing = false;
      ElMessage.success("修改成功");
      await store.dispatch("fileCheckListLevelChange")
    },

    handleCancel(row) {
      row.isEditing = false;
    },
    async handleLocate(row) {
      // showRowBoxImg(row, this.fileInfo.project_id, this.fileInfo.vision_ratio);
      console.log(`准备定位表格行:`, row, this.fileInfo, row, row.keyword);
      await locationByPathKeyword(this.fileInfo.file_path, row.keyword)
    }
  }
};
</script>

<style scoped>
.el-table .cell span:empty {
  display: inline-block;
  width: 100%;
}
</style>